import {SidebarComponent} from "./Sidebar";
import {useNavigate} from "react-router-dom";
import {Fragment, useEffect, useState} from "react";
import {connect} from 'react-redux';
import {actions} from '../../js/redux/auth';
import {DefaultSkeleton} from "../elements/Loader/LoaderComponent";
import {AnimationLayout} from "./AnimationLayout";


function LayoutComponent(props) {
  let navigate = useNavigate();
  const [didMount, setMount] =  useState(false)

  useEffect(()=>{
    setMount(true)
  }, [])

  useEffect(() => {
    if(!props.loaderMe && didMount){
      props.verifySession(navigate)
    }
  }, [props.loaderMe, didMount]);

  return (
    <>
      {
        (!didMount || props.loaderMe) ?
          <DefaultSkeleton/> :
          <Fragment>
            <SidebarComponent {...props} id="sidebar"></SidebarComponent>
            <div
              id="outlet"
              className="h-full pt-5 lg:w-[calc(100%-21rem)] lg:ml-[19rem] lg:mb-0 max-h-[calc(100vh-3rem)] md:pt-5 lg:pt-5 xl:pt-5 mx-5 lg:mx-0 md:mx-0">
              <div className="pb-24 md:pb-0 lg:pb-0">
                <AnimationLayout/>
              </div>
            </div>
          </Fragment>
      }
    </>
  );
}


const states = (state) => {
  return {
    ...state.user,
  };
};


export default connect(states, actions)(LayoutComponent);